import BaseRepository from "./BaseRepository";
import OpenQuote from "../model/OpenQuote";
import OpenQuoteApiCall from "../service/OpenQuoteAPICall";
import { event } from "src/store/slice/system";
import store from "src/storeWire";
import ProductRepository from "./ProductRepository";
import ProductPricingRepository from "./ProductPricingRepository";
import { __remove, __set } from "src/store/axios_indicator";
import { isString } from "underscore";
import CartRepository from "./CartRepository";
import produceClone from "../helper/produceClone";
import ProductPricingAPICall from "src/service/ProductPricingAPICall";
import Common from "src/pages/Quote/Common";

class QuoteRepository extends BaseRepository {
    addOpenQuote = async (quote) => {
        let quoteResponse = {};
        if (quote !== undefined && Object.entries(quote).length > 0) {
            __set('QUOTE_API_CALL');
            quoteResponse = await new OpenQuoteApiCall().addQuote(quote)
        }

        if (Object.entries(quoteResponse.data).length > 0) {
            new OpenQuote().setAddOpenQuote(quoteResponse.data);

            store.dispatch(event({
                event_name: 'AddedToQuote',
                event_data: {
                    quoteResponse
                },
            }));
            __remove('QUOTE_API_CALL');
        }
        return quoteResponse;
    };

    addQuoteInBulk = async (quotes) => {
        if (quotes !== undefined &&
            Object.entries((quotes).length > 0)) {
            let productQuoteData = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(quotes)

            if (productQuoteData !== undefined && Object.entries(productQuoteData).length > 0) {
                const _data = await new CartRepository().getBulkCartItems(productQuoteData);
                const productQuoteItems = produceClone(_data);
                let lineItems = [];
                Object.entries(productQuoteData).map(async (v) => {
                    const getQtyCount = () => {
                        let count = 0;
                        if (productQuoteItems[v[1].ERPPartNumber] !== undefined) {
                            productQuoteItems[v[1].ERPPartNumber].map((v) => {
                                count = count + v.quantity
                            })
                        }
                        return count
                    }
                    let quantity = getQtyCount()
                    let unitPrice = await new ProductPricingRepository().getPricingFromCartPriceBeforeSendToServerByERPPartNumber(v[1].product.ItemNumber)
                    unitPrice = !unitPrice ? 0 : unitPrice
                    if (quantity >= v[1].product.QtyMin && quantity % v[1].product.QtyMult === 0) {
                        if (lineItems.filter(e => e.partNumber === v[1].product.ERPPartNumber).length <= 0) {
                            let lineItemParams = {}
                            lineItemParams.partNumber = v[1].product.ERPPartNumber
                            lineItemParams.manufacturerPartNumber = v[1].product.ManufacturerPartNumber
                            lineItemParams.manufacturerCode = v[1].product.ManufacturerCode
                            lineItemParams.customerPartNumber = ""
                            lineItemParams.quantity1 = quantity
                            lineItemParams.targetCurrency = "EUR"
                            lineItemParams.targetUnitPrice = unitPrice

                            lineItems.push(lineItemParams)
                        }
                    }
                });
                let params = {}
                params.lineItems = lineItems
                await new OpenQuoteApiCall().addQuoteInBulk(params)
                return params.lineItems
            }
            return productQuoteData
        }
        return false;
    };
    // getOpenQuoteList = async (params) => {
    //     let quoteResponse = {};
    //     __set('QUOTE_API_CALL');
    //     console.log("86 opn")
    //     quoteResponse = await new OpenQuoteApiCall().getQuoteList(params);

    //     if (quoteResponse !== undefined && quoteResponse.data !== undefined && quoteResponse.data.length > 0) {
    //         quoteResponse.data.map((v, i) => {
    //             quoteResponse.data[i]['ERPPartNumber'] = v.partNumber;
    //         })
    //     }
    //     __remove('QUOTE_API_CALL');
    //     return quoteResponse;
    // };

    // getOpenQuoteListByERPPartNumbers = async (params) => {
    //     let p = await this.getOpenQuoteList(params);
    //     let b = {};
    //     if (p !== undefined && p.data !== undefined && p.data.length) {
    //         p.data.map((v) => {
    //             b[v.ERPPartNumber] = v;
    //         })
    //     }
    //     new OpenQuote().setOpenQuoteList(b, p);
    //     return b;
    // };

    clearAllQuote = async () => {
        return await new OpenQuoteApiCall().clearAllQuote();
    };

    clearSingleQuote = async (quoteId) => {
        return await new OpenQuoteApiCall().clearSingleQuote(quoteId);
    };

    editQuoteSave = async (quote) => {
        let quoteResponse = {};
        if (quote !== undefined && Object.entries(quote).length > 0) {
            quoteResponse = await new OpenQuoteApiCall().editQuote(quote)
        }


        if (Object.entries(quoteResponse).length > 0) {
            new OpenQuote().setOpenQuoteEditBeforeToSendServer([]);
        }
        return quoteResponse;
    };
    getQuoteMinPriceBySpeedBoat = async () => {
        let quoteResponse = await new OpenQuoteApiCall().getQuoteMinPriceBySpeedBoat();
        if (isString(quoteResponse) && quoteResponse.includes(' ')) {
            return quoteResponse.split(' ');
        }
        return false;
    };
    getSubmittedQuoteList = async (params) => {
        return await new OpenQuoteApiCall().getSubmittedQuoteList(params)
    };
    // getHeaderDetail = async (quoteNumber) => {
    //     return await new OpenQuoteApiCall().getHeaderDetail(quoteNumber)
    // };
    // getLineItemsDetail = async (quoteNumber) => {
    //     return await new OpenQuoteApiCall().getLineItemsDetail(quoteNumber)
    // };
    submitQuote = async (params) => {
        return await new OpenQuoteApiCall().submitQuote(params)
    };
    searchQuote = async (params) => {
        return await new OpenQuoteApiCall().searchQuote(params);
    };

    getOpenQuoteListNew = async (params = {}) => {
        __set('QUOTE_API_CALL');
        const lineItems = await new OpenQuoteApiCall().getOpenQuoteList(params);
        new OpenQuote().setOpenQuoteListNew(lineItems);
        __remove('QUOTE_API_CALL')
        return lineItems;
    };
    addMultipleQuote = async (quotesList) => {
        if (quotesList !== undefined && Object.values((quotesList).length > 0)) {
            let params = {}
            params.lineItems = quotesList
            await new OpenQuoteApiCall().addQuoteInBulk(params)
            return params.lineItems
        }
        return false;
    };

    getRFQQuantity = async (product, cpnNumber) => {
        
        const minPriceRes = await new QuoteRepository().getQuoteMinPriceBySpeedBoat();
        const speedBoatVal = parseInt(minPriceRes[1]);
        const priceParams = [{
            partNumber: product?.ERPPartNumberModified ? '' : product.ERPPartNumber,
            erpManufacturerCode: product.ManufacturerCode,
            erpMfrPartNumber: product.ERPMFRPartNumber,
            customerPartNumber: cpnNumber,
            currency: "EUR"
        }];

        let pricing = await new ProductPricingAPICall().getPricingNew(priceParams, false, false);
        let lowestPrice = 0;
        if (Object.entries(pricing).length > 0) {
            const priceList = (Object.entries(pricing))[0][1]?.prices;
            lowestPrice = new ProductPricingAPICall().getLowestMarketPrice(priceList);
        }
        const minPrice = Common.validateQuantityRFQNew(product.Min, product.Mult, speedBoatVal, lowestPrice);
        
        return minPrice;
    }

    getQuoteReasonList = async () => { // 11360
        let list = []
        const res = await new OpenQuoteApiCall().getQuoteReasonList();
        list = (res?.isSuccessFull && res?.data?.quoteReasons) && res.data.quoteReasons;
        return list;
    };

}

export default QuoteRepository;